import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CopyIcon from "@mui/icons-material/FileCopy";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PrintIcon from "@mui/icons-material/Print";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import copy from "copy-to-clipboard";
import {
  ClientPrintJob,
  InstalledPrinter,
  JSPrintManager,
  WSStatus,
} from "jsprintmanager";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { ToastContainer, toast } from "react-toast";
import Copyright from "../Copyright";
import logo from "../directitgroupcourier.jpg";
import httpRequest from "../HttpService";
import { useUserContext } from "../lib/user_context";
import Gallery from "../newOrder/components/gallery";
import {
  getLocationString,
  getStatusString,
} from "../newOrder/components/helperFunctions/index.js";
import ReactPanZoom from "../newOrder/components/ImagePan";
import PrintPanel from "../newOrder/components/printPanel";
import Carousel from "./components/carouselPanel";
import MapboxPanel from "./components/MapboxPanel/index";
import PageBanner from "./components/pageBanner";
import Panel from "./components/whitePanel";
import "./orderDetail.css";

//  http://localhost:3001/trackNo/TR7991015074139
/* if using orderDetail.js,  the web app would show tracking input page then junping to ordertail page, that's why I made TrackingOrderDetail.js*/

export default function TrackingOrderDetail(props) {
  const { trackingNumber } = useParams();
  const { trackingAccount } = useParams();
  const { trackingReference } = useParams();
  const componentRef = useRef();

  const [photoArray, setPhotoArray] = useState([]);
  const [showDeliveryDetails, setShowDeliveryDetails] = useState(false);
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [order, setOrder] = useState({});
  const [openAddFilesBox, setOpenAddFilesBox] = useState(false);
  const [selectPrinter, setSelectPrinter] = useState(null);
  const [printsList, setPrintsList] = useState([]);
  const [isPrint, setIsPrint] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [isUploadFile, setIsUploadFile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { sessionPreference } = useUserContext();
  const isMobile = useMediaQuery("(max-width:768px)");
  const companyLogo =
    Number(sessionPreference?.companyID) === 5
      ? "https://directitsqlblob.blob.core.windows.net/images/email/argus.png"
      : (order.brandLogoURL?.trim() ? order.brandLogoURL : null);
  // const handleChange = (_event, newValue) => {
  //   console.log("Tab index", newValue);
  //   setTabValue(newValue);
  //   if (newValue == 0 && isUploadFile) {
  //     getPhotos();
  //   }
  // };

  useEffect(() => {
    try {
      let search =
        props.trakingType === "trackingNumber"
          ? { trackingNumber: trackingNumber }
          : {
              cust_ref: trackingReference,
              trackAccount: trackingAccount,
            };

      httpRequest.orderSearch("", search).then((body) => {
        console.log("trackingNumber-" + JSON.stringify(body.data));
        if (body.data.length > 0) {
          let order = body.data[0];
          initOrderDetail(order.ACCOUNT, order.jobID);
        } else window.location.href = "/tracking";
      });

      try {
        JSPrintManager.auto_reconnect = true;
        JSPrintManager.start();
        JSPrintManager.WS.onStatusChanged = () => {
          if (JSPrintManager.websocket_status === WSStatus.Open) {
            JSPrintManager.getPrintersInfo()
              .then(async (printersList) => {
                let printers = printersList.map((item, i) => {
                  return { value: i, label: item.name };
                });
                setPrintsList(printers);
                console.log(
                  "tracking Printer list :" + JSON.stringify(printers),
                );
                var defaultPrinter = printers.find(function (obj) {
                  return obj.label.includes("ZPL");
                });
                console.log(
                  "Final Review Default Printer :" +
                    JSON.stringify(defaultPrinter),
                );
                if (defaultPrinter !== undefined) {
                  var index = printers.findIndex(
                    (x) => x.label === defaultPrinter.label,
                  );
                  setSelectPrinter(printers[index].label);
                }
                console.log("Tracking selectPrinter :" + selectPrinter);
              })
              .catch((err) =>
                console.log("JSPrintManager: Could not get printers:", err),
              );
          }
        };
        JSPrintManager.WS.onError = (err) => {
          console.log(
            "JSPrintManager not available - printing features disabled",
          );
        };
      } catch (e) {
        console.log(
          "JSPrintManager not installed - printing features will be limited:",
          e.message,
        );
      }
    } catch (e) {
      console.log("exception", e);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  const initOrderDetail = (account, orderID) => {
    httpRequest.getOrder(account, orderID).then((response) => {
      console.log("getOrder--" + JSON.stringify(response.data));
      let _order = response.data;
      let extraInfo = {};
      if (_order.extraInfoJSON) {
        try {
          extraInfo = JSON.parse(_order.extraInfoJSON);
        } catch (e) {}
      }
      _order.extraInfo = extraInfo;
      if (_order.dtoDelivered)
        _order.dtDelivered_display = _order.dtoDelivered
          .substring(0, 19)
          .replace("T", " ");
      if (_order.dtoCreated)
        _order.dtCallIn_display = _order.dtoCreated
          .substring(0, 19)
          .replace("T", " ");
      if (_order.dtoDeliverBy)
        _order.dtDCT_display = _order.dtoDeliverBy
          .substring(0, 19)
          .replace("T", " ");
      if (_order.dtoPicked)
        _order.dtPicked_display = _order.dtoPicked
          .substring(0, 19)
          .replace("T", " ");

      _order.del_inTime_display = extraInfo.del_inTime
        ? extraInfo.del_inTime.substring(0, 19).replace("T", " ")
        : "";
      _order.pick_inTime_display = extraInfo.pick_inTime
        ? extraInfo.pick_inTime.substring(0, 19).replace("T", " ")
        : "";
      setOrder(_order);
      setIsLoading(false);
      getOrderTrack(_order.jobID);
      getPhotos(_order.jobID);
      if (_order.Status < 8) {
        const newIntervalId = setInterval(() => {
          getPhotos(_order.jobID);
          httpRequest.getOrder(account, orderID).then((response) => {
            var _order = response.data;
            let extraInfo = {};
            if (_order.extraInfoJSON) {
              try {
                extraInfo = JSON.parse(_order.extraInfoJSON);
              } catch (e) {}
            }
            _order.extraInfo = extraInfo;
            if (_order.dtoDelivered)
              _order.dtDelivered_display = _order.dtoDelivered
                .substring(0, 19)
                .replace("T", " ");
            if (_order.dtoCreated)
              _order.dtCallIn_display = _order.dtoCreated
                .substring(0, 19)
                .replace("T", " ");
            if (_order.dtoDeliverBy)
              _order.dtDCT_display = _order.dtoDeliverBy
                .substring(0, 19)
                .replace("T", " ");
            if (_order.dtoPicked)
              _order.dtPicked_display = _order.dtoPicked
                .substring(0, 19)
                .replace("T", " ");

            _order.del_inTime_display = extraInfo.del_inTime
              ? extraInfo.del_inTime.substring(0, 19).replace("T", " ")
              : "";
            _order.pick_inTime_display = extraInfo.pick_inTime
              ? extraInfo.pick_inTime.substring(0, 19).replace("T", " ")
              : "";
            setOrder(_order);
            getOrderTrack(orderID);

            if (_order.Status >= 8) clearInterval(intervalId);
          });
        }, 60000);
        setIntervalId(newIntervalId);
      }
    });
  };

  const setUploadFileFlag = () => {
    setIsUploadFile(true);
  };

  const getPhotos = (orderID) => {
    //{"url":"https://directitsqlblob.blob.core.windows.net/images/136206101659378995561.png","gpsPoint":null,"comment":"test","drNum":null,"savedTimeUTC":"2022-08-01T18:36:35.763Z","imgID":"7523022"}]
    httpRequest.getPhotoURLs(orderID).then((response) => {
      console.log("getPhotoURLs--" + JSON.stringify(response.data));
      var imageList = [];
      response.data.forEach((value) => {
        value.savedTimeUTC = moment(value.savedTimeUTC).format(
          "YY-MM-DD HH:mm",
        );
        value.id = imageList.length;
        value.imageType =
          value.url.endsWith("png") ||
          value.url.endsWith("jpg") ||
          value.url.endsWith("bmp")
            ? "image"
            : "file";
        value.fileType =
          value.url.endsWith("png") ||
          value.url.endsWith("jpg") ||
          value.url.endsWith("bmp")
            ? "image"
            : value.url.substring(value.url.length - 3);
        value.fileExt = value.url.substring(value.url.length - 3);
        console.log(
          "PhotoURLs--ext is " + value.url.substring(value.url.length - 3),
        );
        if (value.imageType === "image") imageList.push(value);
      });
      setPhotoArray(imageList);
      setIsUploadFile(false);
    });
  };

  const getOrderTrack = (orderID) => {
    httpRequest.getOrderTrack(orderID).then((response) => {
      console.log("getOrderTrack--" + JSON.stringify(response.data));
      var tempTrackList = response.data.map((option, index) => {
        return {
          ...option,
          id: index,
        };
      });
      setSteps(tempTrackList);
      const firstUnfilled = tempTrackList.findIndex((step) => !step.filled);
      setActiveStep(
        firstUnfilled === -1 ? tempTrackList.length : firstUnfilled,
      );
    });
  };

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
  });

  const tzMap = {
    "Pacific Standard Time": "America/Los_Angeles",
    "Mountain Standard Time": "America/Edmonton",
    "Central Standard Time": "America/Chicago",
    "Eastern Standard Time": "America/New_York",
    "Atlantic Standard Time": "America/Halifax",
    "Newfoundland Standard Time": "America/St_Johns",
  };

  const formatOrderTime = (utcTimestamp) => {
    const d = new Date(utcTimestamp);
    const ianaZone = tzMap[order.timezone];
    if (!ianaZone)
      return (
        moment.utc(utcTimestamp).format("MM-DD") +
        " @ " +
        moment.utc(utcTimestamp).format("LT")
      );
    const opts = { timeZone: ianaZone };
    const dateStr = d.toLocaleDateString("en-US", {
      ...opts,
      month: "2-digit",
      day: "2-digit",
    });
    const timeStr = d.toLocaleTimeString("en-US", {
      ...opts,
      hour: "numeric",
      minute: "2-digit",
    });
    const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (ianaZone !== localZone) {
      const tzAbbr = d
        .toLocaleTimeString("en-US", { ...opts, timeZoneName: "short" })
        .split(" ")
        .pop();
      return dateStr + " @ " + timeStr + " " + tzAbbr;
    }
    return dateStr + " @ " + timeStr;
  };

  const renderStepContentText = (label) => {
    return (
      <div>
        <Typography>{label.bigText}</Typography>
        <Typography variant="caption">
          {label.smallText + formatOrderTime(label.timestamp_utc)}
        </Typography>
        {label.img_url && (
          <span>
            <a
              href={label.img_http_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label.img_text}
            </a>
            <div>
              <img
                style={{ width: "80px", height: "60px", cursor: "pointer" }}
                src={label.img_url}
                alt={label.img_text || "Tracking photo"}
                onClick={() => {
                  window.open(label.img_http_link, "_blank");
                }}
              />
            </div>
          </span>
        )}
      </div>
    );
  };

  const renderFromAddress = () => {
    let suite = order.sSuite ? order.sSuite + ", " : "";
    return `${suite} ${order.sAddress}  ${order.sQuad}, ${order.sCity}, ${order.sProv}, ${order.sPostal}, ${order.sCountry}`;
  };

  const renderToAddress = () => {
    let suite = order.cSuite ? order.cSuite + ", " : "";
    return `${suite} ${order.cAddress}  ${order.cQuad}, ${order.cCity}, ${order.cProv}, ${order.cPostal}, ${order.cCountry}`;
  };

  const handleClick = () => {
    setShowDeliveryDetails(!showDeliveryDetails);
  };

  const DetailField = ({ label, value }) => (
    <Grid item xs={12} sm={6} md={4}>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          textTransform: "uppercase",
          letterSpacing: "0.7px",
          color: "text.disabled",
          fontWeight: 700,
          fontSize: "0.62rem",
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.primary", fontWeight: 500, lineHeight: 1.4 }}
      >
        {value || <span style={{ color: "#ccc" }}>—</span>}
      </Typography>
    </Grid>
  );

  const DetailGroup = ({ title, children }) => (
    <Box>
      <Typography
        variant="overline"
        sx={{
          display: "block",
          color: "text.disabled",
          fontWeight: 700,
          letterSpacing: "0.08em",
          fontSize: "0.65rem",
          mb: 1.5,
        }}
      >
        {title}
      </Typography>
      <Grid container rowSpacing={2} columnSpacing={3}>
        {children}
      </Grid>
    </Box>
  );

  const renderDeliveryDetails = () => {
    const tz = order.timezone ? " " + order.timezone : "";
    return (
      <Stack spacing={2.5}>
        <DetailGroup title="Order Info">
          <DetailField label="Caller" value={order.CALLER} />
          <DetailField
            label="Call In"
            value={order.dtCallIn_display ? order.dtCallIn_display + tz : ""}
          />
          <DetailField
            label="Due By"
            value={order.dtDCT_display ? order.dtDCT_display + tz : ""}
          />
          <DetailField label="Service Minutes" value={order.SER_TIME} />
        </DetailGroup>

        <Divider />

        <DetailGroup title="Pickup">
          <DetailField
            label="Driver In"
            value={
              order.pick_inTime_display ? order.pick_inTime_display + tz : ""
            }
          />
          <DetailField
            label="Driver Out"
            value={order.dtPicked_display ? order.dtPicked_display + tz : ""}
          />
          <DetailField
            label="Time Spent"
            value={order.extraInfo?.pick_timeSpent}
          />
        </DetailGroup>

        <Divider />

        <DetailGroup title="Delivery">
          <DetailField
            label="Driver In"
            value={
              order.del_inTime_display ? order.del_inTime_display + tz : ""
            }
          />
          <DetailField
            label="Driver Out"
            value={
              order.dtDelivered_display ? order.dtDelivered_display + tz : ""
            }
          />
          <DetailField
            label="Time Spent"
            value={order.extraInfo?.del_timeSpent}
          />
        </DetailGroup>
      </Stack>
    );
  };

  const StatItem = ({ label, value }) => (
    <Box sx={{ flex: 1, minWidth: 0, px: { xs: 0, sm: 1 } }}>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          color: "text.secondary",
          fontWeight: 600,
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontWeight: 600, color: "text.primary" }}
      >
        {value || <span style={{ color: "#bbb" }}>—</span>}
      </Typography>
    </Box>
  );

  const isDelivered = order.Status >= 8;
  const statusColor = isDelivered ? "success.main" : "primary.main";

  const printClick = () => {
    console.log("selectPrinter :" + selectPrinter);
    if (selectPrinter && selectPrinter.includes("ZPL")) {
      if (JSPrintManager.websocket_status === WSStatus.Open) {
        httpRequest.getLabelString(order.jobID).then(async (body) => {
          //console.log("getZPLLabel return-" + JSON.stringify(body.data));
          var zplLabel = body.data;
          var cpj = new ClientPrintJob();
          cpj.clientPrinter = new InstalledPrinter(selectPrinter);
          cpj.printerCommands = zplLabel.ZPLString;
          cpj.sendToClient();
        });
      }
    } else {
      setIsPrint(true);
    }
  };

  const cancelPrint = () => {
    setIsPrint(false);
  };

  const addFilesClick = () => {
    setOpenAddFilesBox(true);
  };

  const addFilesClose = () => {
    setOpenAddFilesBox(false);
  };

  //   const handleInputChange = (event) => {
  //     const { name, value } = event.target;
  //     this.setState({ [name]: value });
  //   };

  return (
    <Box className="NewOrder">
      <PageBanner
        title="Shipment Tracking"
        subheading={
          order.TrackNumber
            ? "Tracking #" + order.TrackNumber
            : order.jobID
              ? "Job #" + order.jobID
              : ""
        }
      />
      <Container maxWidth="lg">
      <div id="pageContent" style={{ marginTop: "-48px" }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
            <CircularProgress />
          </Box>
        ) : !isPrint ? (
          <Stack spacing={2} sx={{ pb: 4 }}>
            {/* === STATUS HERO === */}
            <Panel>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={3} xl={3}>
                  <Stack
                    spacing={1.5}
                    sx={{
                      borderRight: { lg: "1px solid" },
                      borderBottom: { xs: "1px solid", lg: "none" },
                      borderColor: { xs: "divider", lg: "divider" },
                      pr: { lg: 3 },
                      pb: { xs: 2, lg: 0 },
                    }}
                  >
                    <Box>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          color: "text.secondary",
                          fontWeight: 600,
                        }}
                      >
                        Status
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: 700, color: statusColor, mt: 0.5 }}
                      >
                        {getStatusString(order.Status) || "—"}
                      </Typography>
                    </Box>
                    {order.TrackNumber && (
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            color: "text.secondary",
                            fontWeight: 600,
                          }}
                        >
                          Tracking Number
                        </Typography>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={0.5}
                          sx={{ mt: 0.25 }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              fontFamily: "monospace",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {order.TrackNumber}
                          </Typography>
                          <IconButton
                            size="small"
                            aria-label="copy tracking link"
                            onClick={() => {
                              copy(
                                "https://tracking.directx.ca/trackNo/" +
                                  order.TrackNumber,
                              );
                              toast.success("Tracking link copied");
                            }}
                          >
                            <CopyIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Stack>
                      </Box>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} lg={9} xl={9}>
                  <Stepper
                    activeStep={activeStep}
                    alternativeLabel={!isMobile}
                    orientation={isMobile ? "vertical" : "horizontal"}
                  >
                    {steps.map((label) => (
                      <Step key={label.bigText} completed={label.filled}>
                        <StepLabel>{renderStepContentText(label)}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Grid>
              </Grid>
            </Panel>

            {/* === ROUTE === */}
            <Panel>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                sx={{ mb: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {companyLogo && (
                    <img
                      src={companyLogo}
                      alt="Company Logo"
                      style={{ height: 36, display: "block" }}
                    />
                  )}
                </Box>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={<PrintIcon />}
                  onClick={printClick}
                >
                  Reprint Label
                </Button>
              </Stack>

              <Grid container spacing={2} alignItems="stretch">
                <Grid item xs={12} md>
                  <Stack direction="row" spacing={1.5} alignItems="flex-start">
                    <LocationOnIcon
                      sx={{ color: "text.secondary", mt: 0.25 }}
                      fontSize="small"
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          color: "text.secondary",
                          fontWeight: 600,
                        }}
                      >
                        From
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
                      >
                        {order.sCompanyName || "—"}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {renderFromAddress()}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md="auto"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.disabled",
                  }}
                >
                  <ArrowForwardIcon
                    sx={{ display: { xs: "none", md: "block" } }}
                  />
                </Grid>
                <Grid item xs={12} md>
                  <Stack direction="row" spacing={1.5} alignItems="flex-start">
                    <LocationOnIcon
                      sx={{ color: "primary.main", mt: 0.25 }}
                      fontSize="small"
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          color: "text.secondary",
                          fontWeight: 600,
                        }}
                      >
                        To
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
                      >
                        {order.cCompanyName || "—"}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {renderToAddress()}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2.5 }} />

              {/* Package stats */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 1.5, sm: 0 }}
                divider={
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ display: { xs: "none", sm: "block" } }}
                  />
                }
                sx={{ mb: order.DEL_INST ? 2 : 0 }}
              >
                <StatItem label="Pieces" value={order.PIECES} />
                <StatItem label="Weight" value={order.WEIGHT} />
                {(order.DimsString || order.dimsString) && (
                  <StatItem
                    label="Dims"
                    value={order.DimsString || order.dimsString}
                  />
                )}
                <StatItem label="Service" value={order.serviceText} />
              </Stack>

              {order.DEL_INST && (
                <Box
                  sx={{
                    bgcolor: "rgba(51, 122, 183, 0.06)",
                    borderLeft: "3px solid",
                    borderColor: "primary.main",
                    p: 1.5,
                    borderRadius: "0 4px 4px 0",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      color: "primary.main",
                      fontWeight: 600,
                      mb: 0.25,
                    }}
                  >
                    Special Instructions
                  </Typography>
                  <Typography variant="body2">{order.DEL_INST}</Typography>
                </Box>
              )}
            </Panel>

            {/* === PROOF OF DELIVERY === */}
            {isDelivered && (
              <Panel>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ mb: 2 }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      color: "text.secondary",
                      fontWeight: 600,
                    }}
                  >
                    Proof of Delivery
                  </Typography>
                  {getStatusString(order.Status) && (
                    <Chip
                      label={getStatusString(order.Status)}
                      size="small"
                      color="success"
                      variant="outlined"
                      sx={{ height: 20, fontSize: "0.7rem" }}
                    />
                  )}
                </Stack>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={5}>
                    {order.signatureURL ? (
                      <Box
                        sx={{
                          p: 2,
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 1,
                          bgcolor: "#fafafa",
                          textAlign: "center",
                        }}
                      >
                        <img
                          src={order.signatureURL}
                          alt="Customer Signature"
                          style={{
                            display: "block",
                            width: "100%",
                            maxWidth: 320,
                            margin: "0 auto",
                          }}
                        />
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ display: "block", mt: 1 }}
                        >
                          Signature on file
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          p: 2,
                          border: "1px dashed",
                          borderColor: "divider",
                          borderRadius: 1,
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="body2" color="text.secondary">
                          No signature captured
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Grid container rowSpacing={2} columnSpacing={3}>
                      <DetailField label="Signed By" value={order.PROOF_DEL} />
                      <DetailField
                        label="Delivered"
                        value={
                          order.dtDelivered_display
                            ? order.dtDelivered_display +
                              " " +
                              (order.timezone || "")
                            : ""
                        }
                      />
                      <DetailField
                        label="Delivered To"
                        value={getLocationString(order.location)}
                      />
                      <DetailField
                        label="Billing Reference"
                        value={order.CUST_REF}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Panel>
            )}

            {/* === ADDITIONAL DETAILS (collapsible) === */}
            <Panel>
              <Box
                onClick={handleClick}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  userSelect: "none",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    color: "text.secondary",
                    fontWeight: 600,
                  }}
                >
                  Additional Details
                </Typography>
                {showDeliveryDetails ? (
                  <ExpandLess color="primary" />
                ) : (
                  <ExpandMore color="primary" />
                )}
              </Box>
              <Collapse in={showDeliveryDetails} timeout="auto" unmountOnExit>
                <Box
                  sx={{
                    mt: 2,
                    pt: 2,
                    borderTop: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  {renderDeliveryDetails()}
                </Box>
              </Collapse>
            </Panel>

            {/* === MAP + IMAGES === */}
            <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
              <Box sx={{ flex: 7, minWidth: 0 }}>
                <Panel sx={{ m: 0 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      color: "text.secondary",
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Live Tracking
                  </Typography>
                  {order.jobID && (
                    <MapboxPanel
                      orderID={order.jobID}
                      order={order}
                      photoList={photoArray}
                    />
                  )}
                </Panel>
              </Box>
              <Box sx={{ flex: 5, minWidth: 0 }}>
                <Panel sx={{ m: 0 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 1.5 }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "text.secondary",
                        fontWeight: 600,
                      }}
                    >
                      Images {photoArray.length > 0 && `(${photoArray.length})`}
                    </Typography>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      startIcon={<FileUploadIcon />}
                      onClick={addFilesClick}
                    >
                      Add Files
                    </Button>
                  </Stack>
                  <Carousel
                    show={photoArray.length !== 0 ? true : false}
                    numOfImages={photoArray.length}
                  >
                    {photoArray.map((image, i) => (
                      <div
                        key={i}
                        style={{
                          justifyContent: "center",
                          height: "50%",
                          verticalAlign: "middle",
                          display: "flex",
                        }}
                      >
                        <ReactPanZoom src={image.url} />
                      </div>
                    ))}
                  </Carousel>
                </Panel>
              </Box>
            </Stack>
          </Stack>
        ) : (
          <Panel>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setIsPrint(false);
              }}
              style={{ float: "right", margin: "2px" }}
            >
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handlePrint}>
              {" "}
              Print
            </Button>
            <div ref={componentRef}>
              <PrintPanel
                id={order.jobID}
                account={order.ACCOUNT}
                logoUrl={companyLogo}
              />
            </div>
          </Panel>
        )}
      </div>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        className="addFilesDialog"
        open={openAddFilesBox}
        onClose={addFilesClose}
      >
        <DialogTitle>Add Files</DialogTitle>
        <DialogContent>
          <Gallery jobId={order.jobID} setUploadFileFlag={setUploadFileFlag} />
        </DialogContent>
        <DialogActions>
          <Button onClick={addFilesClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
      <footer>
        {" "}
        <Copyright />{" "}
      </footer>
      </Container>
    </Box>
  );
}
